(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beiko-video-serie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('beiko-video-serie')) return;

    class BeikoVideoSerie extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-bvs-item]'));
        this.tabs = Array.from(this.querySelectorAll('[data-bvs-tab]'));
        this.ctas = Array.from(this.querySelectorAll('[data-bvs-cta]'));
        this.list = this.querySelector('[data-bvs-list]');

        this.querySelectorAll('[data-bvs-newsletter]').forEach((link) => {
          link.addEventListener('click', (event) => this.goToNewsletter(event));
        });

        if (!this.items.length) return;
        if (!this.items.some((item) => !item.hidden)) this.select(this.items[0].dataset.chapitre, false);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(tab.dataset.chapitre, true));
        });

        this.items.forEach((item) => {
          const video = item.querySelector('video');
          if (!video) return;
          video.addEventListener('play', () => this.track('beiko_video_play', { chapitre: Number(item.dataset.chapitre) }), { once: true });
          video.addEventListener('ended', () => this.next(item.dataset.chapitre));
        });
      }

      currentVideo() {
        const item = this.items.find((i) => !i.hidden);
        return item ? item.querySelector('video') : null;
      }

      select(chapitre, play) {
        this.items.forEach((item) => {
          const isOn = item.dataset.chapitre === chapitre;
          const video = item.querySelector('video');
          if (!isOn && video && !video.paused) video.pause();
          item.hidden = !isOn;
        });
        this.tabs.forEach((tab) => tab.setAttribute('aria-current', String(tab.dataset.chapitre === chapitre)));
        this.ctas.forEach((cta) => {
          cta.hidden = cta.dataset.chapitre !== chapitre;
        });

        const tab = this.tabs.find((t) => t.dataset.chapitre === chapitre);
        if (tab && this.list && this.list.scrollWidth > this.list.clientWidth + 4) {
          this.list.scrollTo({ left: Math.max(0, tab.parentElement.offsetLeft - 16), behavior: 'smooth' });
        }

        if (play) {
          const video = this.currentVideo();
          if (video) {
            const promise = video.play();
            if (promise && promise.catch) promise.catch(() => {});
          }
        }
      }

      next(chapitre) {
        const index = this.tabs.findIndex((t) => t.dataset.chapitre === chapitre);
        const nextTab = this.tabs[index + 1];
        if (nextTab) this.select(nextTab.dataset.chapitre, true);
      }

      goToNewsletter(event) {
        const forms = Array.from(document.querySelectorAll('form')).filter(
          (form) => !this.contains(form) && form.querySelector('input[type="email"]')
        );
        const form = forms.find((f) => f.classList.contains('email-signup__form')) || forms[forms.length - 1];
        if (!form) return;
        event.preventDefault();
        this.currentVideo()?.pause();
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const input = form.querySelector('input[type="email"]');
        window.setTimeout(() => {
          if (input) input.focus({ preventScroll: true });
          form.classList.remove('bvs-flash');
          void form.offsetWidth;
          form.classList.add('bvs-flash');
        }, 700);
        this.track('beiko_newsletter_click', {});
      }

      track(name, data) {
        try {
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish(name, Object.assign({ page: this.dataset.context || '' }, data));
          }
        } catch (e) {}
      }
    }

    customElements.define('beiko-video-serie', BeikoVideoSerie);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
